$(document).ready(function() {  
    $('.footer__item--social-media .footer__item-content').prepend('<img src="https://d1yvdgbmeqok5q.cloudfront.net/cleo-and-wolf/img/CW_Logo.png">');
  var techArray = ["Composite Safety Toe","Electrical Hazard","Flame Resistant","High-Visibility","Insulated","Made in USA","Puncture Resistant","Slip Resistant","Steel Toe","Waterproof","Aislado","Aislada","Impermeable","Stretch","Mild Cold","Handcrafted","Cold","Size Runs Small"];

  // MutationObserver is used to detect changes in the DOM
  const watcher = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
              // Check for added nodes with the specified class
              $(mutation.addedNodes).find('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                  $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                      var value = $(this).find('.checkbox').val();
                      if ($.inArray(value, techArray) !== -1) {
                          $(this).closest('.checkbox-container').addClass('show');
                      } else {
                          $(this).closest('.checkbox-container').addClass('hidden');
                      }
                  });
              });

              // Check for added nodes that are the element with the specified class
               $(mutation.addedNodes).filter('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                 $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
                      var value = $(this).find('.checkbox').val();
                      if ($.inArray(value, techArray) !== -1) {
                          $(this).closest('.checkbox-container').addClass('show');
                      } else {
                          $(this).closest('.checkbox-container').addClass('hidden');
                      }
                  });
              });
          }
      });
    if ($('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container.show').length == 0) {
      $('collapsible-content[id="facet-filter-filter.p.tag"]').closest('.product-facet__filter-item').hide();
    }
  });

  // Configure the observer to watch for changes to the element's children
  const config = { childList: true, subtree: true };

  // Start observing the document body for changes
  watcher.observe(document.body, config);

  // Initial check for existing elements on page load
   $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
     $('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container').each(function() {
          var value = $(this).find('.checkbox').val();
          if ($.inArray(value, techArray) !== -1) {
              $(this).closest('.checkbox-container').addClass('show');
          } else {
              $(this).closest('.checkbox-container').addClass('hidden');
          }
      });
  });
  if ($('collapsible-content[id="facet-filter-filter.p.tag"] .checkbox-container.show').length == 0) {
      $('collapsible-content[id="facet-filter-filter.p.tag"]').closest('.product-facet__filter-item').hide();
  }
});


//collapse description toggle when mobile
$(document).ready(function() {
  $('.product-tabs__tab-item-content br').remove();
  /*if ($(window).width() > 790) { 
    $('.shopify-section--product-content button.collapsible-toggle').trigger('click');
  }*/
});